﻿export enum SearchParameter {
  Milestone = "milestone",
  /** @deprecated former search parameter syntax for milestone, use {@link Milestone} instead */
  ExpandMilestone = "expand-milestone",
  Schedule = "schedule",
}
